<template>
  <section>
    <b-overlay
      :show="loading"
      rounded
      opacity="0.7"
      spinner-small
      spinner-variant="primary"
      class="d-inline-block w-100 mb-5"
    >
      <section class="container-resume" v-if="importsEmailsPlanRelease && importsEmailsPlanRelease._id">
        <p class="title-group mb-3">Log da importação</p>

        <b-row>
          <!-- Resumo da operação -->
          <b-col cols="12" class="mb-3">
            <b-card no-body class="resume-b-card">
              <div v-b-toggle.collapse-resume class="py-3 resume-b-card__header" :class="{ 'resume-b-card__header--collapsed': !showResume }" @click="showResume = !showResume">
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 3h4v14H3V3Zm5 5h4v9H8V8Zm5-4h4v13h-4V4Z" fill="#022245"/>
                </svg>
                <span>Resumo da operação</span>
                <svg class="resume-b-card__chevron" :class="{ 'resume-b-card__chevron--open': showResume }" width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 7.5 10 12.5 15 7.5" stroke="#022245" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <b-collapse id="collapse-resume">
                <b-card-body>
              <b-row>
                <b-col cols="6" md="3" class="mb-2">
                  <b-card class="stat-b-card stat-b-card--neutral h-100" body-class="text-center py-3">
                    <div class="stat-b-card__value">{{ total }}</div>
                    <div class="stat-b-card__label">Registros processados</div>
                  </b-card>
                </b-col>
                <b-col cols="6" md="3" class="mb-2">
                  <b-card class="stat-b-card stat-b-card--success h-100" body-class="text-center py-3">
                    <div class="stat-b-card__value">{{ successBreakdown['Liberação de plano'] || 0 }}</div>
                    <div class="stat-b-card__label">Liberação de plano</div>
                  </b-card>
                </b-col>
                <b-col cols="6" md="3" class="mb-2">
                  <b-card class="stat-b-card stat-b-card--success h-100" body-class="text-center py-3">
                    <div class="stat-b-card__value">{{ successBreakdown['Atualizou a data de vencimento do plano'] || 0 }}</div>
                    <div class="stat-b-card__label">Vencimento do plano atualizado</div>
                  </b-card>
                </b-col>
                <b-col cols="6" md="3" class="mb-2">
                  <b-card class="stat-b-card stat-b-card--success h-100" body-class="text-center py-3">
                    <div class="stat-b-card__value">{{ successBreakdown['Nova'] || 0 }}</div>
                    <div class="stat-b-card__label">Convite enviado</div>
                  </b-card>
                </b-col>
                <b-col cols="6" md="3" class="mb-2">
                  <b-card class="stat-b-card stat-b-card--warning h-100" body-class="text-center py-3">
                    <div class="stat-b-card__value">{{ pendingCpf.meta.total }}</div>
                    <div class="stat-b-card__label">Aguardando regularização (conflito de CPF)</div>
                  </b-card>
                </b-col>
                <b-col cols="6" md="3" class="mb-2">
                  <b-card class="stat-b-card stat-b-card--warning h-100" body-class="text-center py-3">
                    <div class="stat-b-card__value">{{ pendingPlan.meta.total }}</div>
                    <div class="stat-b-card__label">Aguardando verificação (Plano ativo)</div>
                  </b-card>
                </b-col>
                <b-col cols="6" md="3" class="mb-2">
                  <b-card class="conversion-b-card h-100" body-class="conversion-b-card__body">
                    <span class="conversion-item__label">Taxa de conversão (mensal)</span>
                    <span class="conversion-item__value">
                      {{ formatRate(conversion.monthlyRate) }}
                      <small>({{ conversion.boughtMonthly }})</small>
                    </span>
                  </b-card>
                </b-col>
                <b-col cols="6" md="3" class="mb-2">
                  <b-card class="conversion-b-card h-100" body-class="conversion-b-card__body">
                    <span class="conversion-item__label">Taxa de conversão (anual)</span>
                    <span class="conversion-item__value">
                      {{ formatRate(conversion.annualRate) }}
                      <small>({{ conversion.boughtAnnual }})</small>
                    </span>
                  </b-card>
                </b-col>
              </b-row>
                </b-card-body>
              </b-collapse>
            </b-card>
          </b-col>

          <!-- Detalhes da importação -->
          <b-col cols="12" class="mb-3">
            <b-card no-body class="resume-b-card">
              <div v-b-toggle.collapse-details class="py-3 resume-b-card__header" :class="{ 'resume-b-card__header--collapsed': !showDetails }" @click="showDetails = !showDetails">
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 2h8l4 4v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm8 1.5V6h2.5L12 3.5Z" fill="#022245"/>
                </svg>
                <span>Detalhes da importação</span>
                <svg class="resume-b-card__chevron" :class="{ 'resume-b-card__chevron--open': showDetails }" width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 7.5 10 12.5 15 7.5" stroke="#022245" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <b-collapse id="collapse-details">
              <ul class="detail-list">
                <li class="detail-list__item">
                  <span class="detail-list__label">ID da importação</span>
                  <span class="detail-list__value detail-list__value--mono">{{ importsEmailsPlanRelease._id }}</span>
                </li>
                <li class="detail-list__item">
                  <span class="detail-list__label">Data e hora</span>
                  <span class="detail-list__value">{{ formatDateComplete(importsEmailsPlanRelease.createdAt) }}</span>
                </li>
                <li class="detail-list__item">
                  <span class="detail-list__label">Data de vencimento do acesso</span>
                  <span class="detail-list__value">{{ formatDateOnly(importsEmailsPlanRelease.accessExpirationDate) }}</span>
                </li>
                <li class="detail-list__item">
                  <span class="detail-list__label">Importado por</span>
                  <span class="detail-list__value">{{ importsEmailsPlanRelease && importsEmailsPlanRelease.user && importsEmailsPlanRelease.user.username ? importsEmailsPlanRelease.user.username : '-' }}</span>
                </li>
                <li class="detail-list__item">
                  <span class="detail-list__label">Arquivo de origem</span>
                  <span class="detail-list__value">{{ importsEmailsPlanRelease.fileName }}</span>
                </li>
              </ul>
              </b-collapse>
            </b-card>
          </b-col>
        </b-row>
      </section>

      <section class="mt-3">
        <p class="title-group mb-2">
          <strong>Grupo 1: Acesso liberado imediatamente ({{ success.meta.total }}
            {{ success.meta.total > 1 ? 'usuários' : 'usuário' }})</strong>
        </p>

        <section class="alert-success-group d-inline-flex align-items-center justify-content-start mb-3 p-2 w-100">
          <section>
            <svg width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9 15H11V9H9V15ZM10 7C10.2833 7 10.521 6.904 10.713 6.712C10.905 6.52 11.0007 6.28267 11 6C11 5.71667 10.904 5.479 10.712 5.287C10.52 5.095 10.2827 4.99933 10 5C9.71667 5 9.479 5.096 9.287 5.288C9.095 5.48 8.99933 5.71733 9 6C9 6.28333 9.096 6.521 9.288 6.713C9.48 6.905 9.71733 7.00067 10 7ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6867 3.825 17.9743 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.263333 12.6833 0.000666667 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.825 2.025 4.88333 1.31267 6.1 0.788C7.31667 0.263333 8.61667 0.000666667 10 0C11.3833 0 12.6833 0.262667 13.9 0.788C15.1167 1.31333 16.175 2.02567 17.075 2.925C17.975 3.825 18.6877 4.88333 19.213 6.1C19.7383 7.31667 20.0007 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6867 15.1167 17.9743 16.175 17.075 17.075C16.175 17.975 15.1167 18.6877 13.9 19.213C12.6833 19.7383 11.3833 20.0007 10 20Z"
                fill="#022245" />
            </svg>
          </section>
          <section class="ml-3">
            <p class="mb-1">Estes usuários não apresentam conflitos e o acesso já foi concedido ou o convite
              enviado.</p>
            <p class="mb-1">Observação para a equipe: Nenhuma ação manual é necessária para este grupo.</p>
          </section>
        </section>

        <section class="d-flex align-items-center mb-3" style="gap: 12px;">
          <b-form-input v-model="filters.success.search" class="w-50" placeholder="Pesquisar por: e-mail ou nome" type="text" @keydown.enter.prevent="applyGroupFilter('success')" />
          <b-button variant="primary" @click="applyGroupFilter('success')">Buscar</b-button>
          <b-button variant="outline-secondary" :disabled="!filters.success.search" @click="clearGroupFilter('success')">Limpar</b-button>
        </section>

        <table border="1" cellspacing="0" cellpadding="8" style="width:100%; " class="border-none">
          <thead style="background-color:#0b2d4d; color:#fff;">
          <tr class="text-center w-100">
            <th class="py-3 border-none w-11">E-mail</th>
            <th class="py-3 border-none w-11">Nome do cliente</th>
            <th class="py-3 border-none w-11">Status / Ação realizada</th>
            <th class="py-3 border-none w-11">Quando pesquisou o primeiro agente</th>
            <th class="py-3 border-none w-11">Quando recebeu o acesso</th>
            <th class="py-3 border-none w-11">Qtd de agentes pesquisados</th>
            <th class="py-3 border-none w-11">Dias até ativar o acesso</th>
            <th class="py-3 border-none w-11">Comprou?</th>
            <th class="py-3 border-none w-11">Tempo até comprar</th>
          </tr>
          </thead>
          <tbody
            v-if="success && success.itens && success.itens.length > 0"
          >
          <tr
            class="text-center w-100"
            v-for="item in success.itens"
            :key="item._id"
            style="border: 1px solid #EDEDED;background: #FFFFFF "
          >
            <td class="py-3 border-none file-name-access-expiration-date px-1 w-11">
              {{ item && item.emailFile ? item.emailFile: '-' }}
            </td>

            <td class="py-3 border-none file-name-access-expiration-date px-1 w-11">
              {{ item && item.nameFile ? item.nameFile : '-' }}
            </td>

            <td class="py-3 border-none file-name-access-expiration-date px-1 w-11">
              <div class="d-flex align-items-center justify-content-center">
                <strong>{{ statusLabel(item) }}</strong>
                <template v-if="statusLabel(item) === 'Nova'">
                  <b-icon
                    :id="`invitation-${item._id}`"
                    class="ml-2 invitation-icon"
                    icon="info-circle"
                    font-scale="1"
                  />
                  <b-popover
                    :target="`invitation-${item._id}`"
                    placement="auto"
                    triggers="hover focus"
                    custom-class="invitation-popover"
                  >
                    <template #title>Detalhes do convite</template>
                    <div class="text-left invitation-popover-body">
                      <div><strong>Situação:</strong> {{ invitationStatus(item) }}</div>
                      <template v-if="item.invitation">
                        <div><strong>Enviado em:</strong> {{ item.invitation.createdAt ? formatDateComplete(item.invitation.createdAt) : '-' }}</div>
                        <div><strong>Acesso válido até:</strong> {{ formatDateOnly(item.invitation.accessExpirationDate) }}</div>
                        <div><strong>Conta criada:</strong> {{ item.invitation.userRegistered ? 'Sim' : 'Não' }}</div>
                      </template>
                    </div>
                  </b-popover>
                </template>
              </div>
              <div class="action-text mt-1">{{ actionLabel(item) }}</div>
            </td>

            <td class="py-3 border-none file-name-access-expiration-date px-1 w-11">
              {{getWhenHeResearchedTheFirstAgent(item) }}
            </td>

            <td class="py-3 border-none file-name-access-expiration-date px-1 w-11">
              {{formatDateComplete(item.createdAt) }}
            </td>

            <td class="py-3 border-none file-name-access-expiration-date px-1 w-11">
              {{ item.chemicalAgentsResearched ? item.chemicalAgentsResearched.length : 0 }}
            </td>

            <td class="py-3 border-none file-name-access-expiration-date px-1 w-11">
              {{ getActivationDays(item) }}
            </td>

            <td class="py-3 border-none file-name-access-expiration-date px-1 w-11">
              <template v-if="item.purchase && item.purchase.bought">
                <div><strong>Sim — {{ item.purchase.type }}</strong></div>
                <div class="mt-1">{{ item.purchase.date ? formatDateShort(item.purchase.date) : '-' }}</div>
              </template>
              <template v-else>Não</template>
            </td>

            <td class="py-3 border-none file-name-access-expiration-date px-1 w-11">
              {{ getDaysUntilPurchase(item) }}
            </td>
          </tr>
          </tbody>

          <tbody v-else>
          <tr
            class="text-center w-100"
            style="border: 1px solid #EDEDED;background: #FFFFFF "
          >
            <td colspan="9" class="py-3 border-none file-name-access-expiration-date px-1 w-100">
              <strong>Nenhum registro encontrado!</strong>
            </td>
          </tr>
          </tbody>
        </table>

        <b-pagination
          v-if="success.meta.total > 15"
          align="center"
          class="mt-3"
          :per-page="15"
          v-model="success.meta.page"
          :total-rows="success.meta.total"
          first-text="⏮"
          prev-text="⏪"
          next-text="⏩"
          last-text="⏭"
          @page-click="(e, page) => changePage('success', page)"
        />
      </section>

      <section class="mt-5">
        <p class="title-group mb-2">
          <strong>
            Grupo 2: Contato necessário para regularização de CPF ({{ pendingCpf.meta.total }}
            {{ pendingCpf.meta.total > 1 ? 'usuários' : 'usuário' }})
          </strong>
        </p>

        <section class="alert-pending-group d-inline-flex align-items-center justify-content-start mb-3 p-2 w-100">
          <section>
            <svg width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9 15H11V9H9V15ZM10 7C10.2833 7 10.521 6.904 10.713 6.712C10.905 6.52 11.0007 6.28267 11 6C11 5.71667 10.904 5.479 10.712 5.287C10.52 5.095 10.2827 4.99933 10 5C9.71667 5 9.479 5.096 9.287 5.288C9.095 5.48 8.99933 5.71733 9 6C9 6.28333 9.096 6.521 9.288 6.713C9.48 6.905 9.71733 7.00067 10 7ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6867 3.825 17.9743 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.263333 12.6833 0.000666667 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.825 2.025 4.88333 1.31267 6.1 0.788C7.31667 0.263333 8.61667 0.000666667 10 0C11.3833 0 12.6833 0.262667 13.9 0.788C15.1167 1.31333 16.175 2.02567 17.075 2.925C17.975 3.825 18.6877 4.88333 19.213 6.1C19.7383 7.31667 20.0007 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6867 15.1167 17.9743 16.175 17.075 17.075C16.175 17.975 15.1167 18.6877 13.9 19.213C12.6833 19.7383 11.3833 20.0007 10 20Z"
                fill="#CD0000" />
            </svg>

          </section>
          <section class="ml-3">
            <p class="mb-1">
              A importação foi pausada para estes usuários pois o CPF informado no arquivo já está cadastrado com outro e-mail na plataforma.
            </p>
            <p class="mb-1">
              Ação recomendada: Entrar em contato com cada usuário para confirmar o e-mail correto vinculado ao CPF e reprocessar o acesso manualmente.
            </p>
          </section>
        </section>

        <section class="d-flex align-items-center mb-3" style="gap: 12px;">
          <b-form-input v-model="filters.pendingCpf.search" class="w-50" placeholder="Pesquisar por: e-mail ou nome" type="text" @keydown.enter.prevent="applyGroupFilter('pendingCpf')" />
          <b-button variant="primary" @click="applyGroupFilter('pendingCpf')">Buscar</b-button>
          <b-button variant="outline-secondary" :disabled="!filters.pendingCpf.search" @click="clearGroupFilter('pendingCpf')">Limpar</b-button>
        </section>

        <table border="1" cellspacing="0" cellpadding="8" style="width:100%; " class="border-none">
          <thead style="background-color:#0b2d4d; color:#fff;">
          <tr class="text-center w-100">
            <th class="py-3 border-none w-25">E-mail (do arquivo)</th>
            <th class="py-3 border-none w-25">Nome (do arquivo)</th>
            <th class="py-3 border-none w-25">CPF conflitante</th>
            <th class="py-3 border-none w-25">E-mail já cadastrado com este CPF</th>
          </tr>
          </thead>
          <tbody
            v-if="pendingCpf && pendingCpf.itens && pendingCpf.itens.length > 0"
          >
          <tr
            class="text-center w-100"
            v-for="item in pendingCpf.itens"
            :key="item._id"
            style="border: 1px solid #EDEDED;background: #FFFFFF "
          >
            <td class="py-3 border-none file-name-access-expiration-date px-1 w-25">
              {{ item.emailFile ? item.emailFile : '-' }}
            </td>
            <td class="py-3 border-none file-name-access-expiration-date px-1 w-25">
              {{ item.nameFile ? item.nameFile : '-' }}
            </td>
            <td class="py-3 border-none file-name-access-expiration-date px-1 w-25">
              {{ item.cpfConflicting ? item.cpfConflicting : '-' }}
            </td>
            <td class="py-3 border-none file-name-access-expiration-date px-1 w-25">
              {{ item.emailAlreadyRegisteredCpf ? item.emailAlreadyRegisteredCpf : '-' }}
            </td>
          </tr>
          </tbody>

          <tbody v-else>
          <tr
            class="text-center w-100"
            style="border: 1px solid #EDEDED;background: #FFFFFF "
          >
            <td colspan="4" class="py-3 border-none file-name-access-expiration-date px-1 w-25">
              <strong>Nenhum registro encontrado!</strong>
            </td>
          </tr>
          </tbody>
        </table>

        <b-pagination
          v-if="pendingCpf.meta.total > 15"
          align="center"
          class="mt-3"
          :per-page="15"
          v-model="pendingCpf.meta.page"
          :total-rows="pendingCpf.meta.total"
          first-text="⏮"
          prev-text="⏪"
          next-text="⏩"
          last-text="⏭"
          @page-click="(e, page) => changePage('pendingCpf', page)"
        />
      </section>

      <section class="mt-5">
        <p class="title-group mb-2">
          <strong>
            Grupo 3: Contato necessário para definição do acesso ({{ pendingPlan.meta.total }}
            {{ pendingPlan.meta.total > 1 ? 'usuários' : 'usuário' }})
          </strong>
        </p>

        <section class="alert-pending-group d-inline-flex align-items-center justify-content-start mb-3 p-2 w-100">
          <section>
            <svg width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9 15H11V9H9V15ZM10 7C10.2833 7 10.521 6.904 10.713 6.712C10.905 6.52 11.0007 6.28267 11 6C11 5.71667 10.904 5.479 10.712 5.287C10.52 5.095 10.2827 4.99933 10 5C9.71667 5 9.479 5.096 9.287 5.288C9.095 5.48 8.99933 5.71733 9 6C9 6.28333 9.096 6.521 9.288 6.713C9.48 6.905 9.71733 7.00067 10 7ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6867 3.825 17.9743 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.263333 12.6833 0.000666667 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.825 2.025 4.88333 1.31267 6.1 0.788C7.31667 0.263333 8.61667 0.000666667 10 0C11.3833 0 12.6833 0.262667 13.9 0.788C15.1167 1.31333 16.175 2.02567 17.075 2.925C17.975 3.825 18.6877 4.88333 19.213 6.1C19.7383 7.31667 20.0007 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6867 15.1167 17.9743 16.175 17.075 17.075C16.175 17.975 15.1167 18.6877 13.9 19.213C12.6833 19.7383 11.3833 20.0007 10 20Z"
                fill="#CD0000" />
            </svg>

          </section>
          <section class="ml-3">
            <p class="mb-1">
              A importação foi pausada para estes usuários, pois eles já possuem um plano ativo.
            </p>
            <p class="mb-1">
              Ação recomendada: Entrar em contato com cada usuário para decidir se o novo acesso será somado ao atual,
              se substituirá o plano vigente ou se a liberação será descartada.
            </p>
          </section>
        </section>

        <section class="d-flex align-items-center mb-3" style="gap: 12px;">
          <b-form-input v-model="filters.pendingPlan.search" class="w-50" placeholder="Pesquisar por: e-mail ou nome" type="text" @keydown.enter.prevent="applyGroupFilter('pendingPlan')" />
          <b-button variant="primary" @click="applyGroupFilter('pendingPlan')">Buscar</b-button>
          <b-button variant="outline-secondary" :disabled="!filters.pendingPlan.search" @click="clearGroupFilter('pendingPlan')">Limpar</b-button>
        </section>

        <table border="1" cellspacing="0" cellpadding="8" style="width:100%; " class="border-none">
          <thead style="background-color:#0b2d4d; color:#fff;">
          <tr class="text-center w-100">
            <th class="py-3 border-none w-20">E-mail</th>
            <th class="py-3 border-none w-20">Nome do cliente</th>
            <th class="py-3 border-none w-20">Plano Ativo</th>
            <th class="py-3 border-none w-20">Status do Plano</th>
            <th class="py-3 border-none w-20">Vencimento do Plano Atual</th>
          </tr>
          </thead>
          <tbody
            v-if="pendingPlan && pendingPlan.itens && pendingPlan.itens.length > 0"
          >
          <tr
            class="text-center w-100"
            v-for="item in pendingPlan.itens"
            :key="item._id"
            style="border: 1px solid #EDEDED;background: #FFFFFF "
          >
            <td class="py-3 border-none file-name-access-expiration-date px-1 w-20">
              {{ item && item.user && item.user.username ? item.user.username : '-' }}
            </td>
            <td class="py-3 border-none file-name-access-expiration-date px-1 w-20">
              {{ item && item.user && item.user.profile && item.user.profile.name ? item.user.profile.name : '-' }}
            </td>
            <td class="py-3 border-none file-name-access-expiration-date px-1 w-20">
              {{ item && item.userPlan && item.userPlan.plan ? planName(item.userPlan.plan) : '-' }}
            </td>
            <td class="py-3 border-none file-name-access-expiration-date px-1 w-20">
              {{ item && item.userPlan && item.userPlan.status ? planStatus(item.userPlan.status) : '-' }}
            </td>
            <td class="py-3 border-none file-name-access-expiration-date px-1 w-20">
              {{ item && item.userPlan && item.userPlan.dueDate ? formatDate(item.userPlan.dueDate) : '-' }}
            </td>
          </tr>
          </tbody>

          <tbody v-else>
          <tr
            class="text-center w-100"
            style="border: 1px solid #EDEDED;background: #FFFFFF "
          >
            <td colspan="5" class="py-3 border-none file-name-access-expiration-date px-1 w-25">
              <strong>Nenhum registro encontrado!</strong>
            </td>
          </tr>
          </tbody>
        </table>

        <b-pagination
          v-if="pendingPlan.meta.total > 15"
          align="center"
          class="mt-3"
          :per-page="15"
          v-model="pendingPlan.meta.page"
          :total-rows="pendingPlan.meta.total"
          first-text="⏮"
          prev-text="⏪"
          next-text="⏩"
          last-text="⏭"
          @page-click="(e, page) => changePage('pendingPlan', page)"
        />
      </section>
    </b-overlay>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import format from 'date-fns/esm/format/index'

export default {
  name: 'ImportEmailsPlanReleaseLog',
  components: {},
  created() {
    const breadcrumb = {
      page: 'Importação de lista de e-mails',
      subPage: {
        name: 'Libere acesso do plano anual com prazo pré-determinado',
        active: false
      },
      tabs: []
    }
    this.setBreadcrumb(breadcrumb)
  },
  data() {
    return {
      loading: false,
      showResume: false,
      showDetails: false,
      total: 0,
      filters: {
        success: { search: '' },
        pendingCpf: { search: '' },
        pendingPlan: { search: '' }
      },
      importsEmailsPlanRelease: {},
      conversion: { total: 0, boughtMonthly: 0, boughtAnnual: 0, monthlyRate: 0, annualRate: 0 },
      success: { itens: [], meta: { page: 1, limit: 15, total: 0 } },
      pendingCpf: { itens: [], meta: { page: 1, limit: 15, total: 0 } },
      pendingPlan: { itens: [], meta: { page: 1, limit: 15, total: 0 } }
    }
  },
  async mounted() {
    try {
      const { _id } = this.$route.params
      this.loading = true
      await Promise.all([
        this.fetchGroup('success'),
        this.fetchGroup('pendingCpf'),
        this.fetchGroup('pendingPlan'),
        this.fetchConversion()
      ])
      const { data: dataImportEmailsPlanRelease } = await this.handleGetImportEmailsPlanRelease(_id)
      this.importsEmailsPlanRelease = dataImportEmailsPlanRelease.data || {}
    } catch (e) {
      this.$bvToast.toast('Ocorreu um erro ao carregar os dados. Tente novamente.', {
        title: 'Atenção',
        variant: 'danger',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 5000,
      })
    } finally {
      this.loading = false
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/current']
    },
    error() {
      return this.$store.getters['access/error']
    },
    successBreakdown() {
      return (this.success && this.success.meta && this.success.meta.breakdown) || {}
    }
  },
  methods: {
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb'
    }),
    ...mapActions('importEmailsPlanRelease', {
      handleGetImportEmailsPlanReleaseLog: 'handleGetImportEmailsPlanReleaseLog',
      handleGetImportEmailsPlanRelease: 'handleGetImportEmailsPlanRelease',
      handleGetImportEmailsPlanReleaseConversion: 'handleGetImportEmailsPlanReleaseConversion'
    }),
    async fetchGroup(type, page = 1) {
      const { _id } = this.$route.params
      const { data } = await this.handleGetImportEmailsPlanReleaseLog({
        importEmailsPlanReleaseId: _id,
        type,
        page,
        limit: 15,
        search: this.filters[type].search
      })
      this[type] = {
        itens: data && data.items ? data.items : [],
        meta: data && data.meta ? data.meta : { page, limit: 15, total: 0 }
      }
      this.total = this.success.meta.total + this.pendingCpf.meta.total + this.pendingPlan.meta.total
    },
    async fetchConversion() {
      const { _id } = this.$route.params
      const { data } = await this.handleGetImportEmailsPlanReleaseConversion(_id)
      this.conversion = data || { total: 0, boughtMonthly: 0, boughtAnnual: 0, monthlyRate: 0, annualRate: 0 }
    },
    async applyGroupFilter(type) {
      this.loading = true
      try {
        await this.fetchGroup(type)
      } finally {
        this.loading = false
      }
    },
    async clearGroupFilter(type) {
      this.filters[type].search = ''
      await this.applyGroupFilter(type)
    },
    async changePage(type, page) {
      this.loading = true
      try {
        await this.fetchGroup(type, page)
      } finally {
        this.loading = false
      }
    },
    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy')
    },
    formatDateShort(date) {
      return format(new Date(date), 'dd/MM/yy')
    },
    formatDateComplete(date) {
      return format(new Date(date), 'dd/MM/yyyy HH:mm:ss')
    },
    formatDateOnly(date) {
      if (!date) {
        return '-'
      }
      // Handle date-only strings (YYYY-MM-DD) without timezone shift
      const dateOnlyMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(date)
      if (dateOnlyMatch) {
        const [, year, month, day] = dateOnlyMatch
        return `${day}/${month}/${year}`
      }
      return format(new Date(date), 'dd/MM/yyyy')
    },
    formatRate(rate) {
      const value = Number(rate) || 0
      return `${(value * 100).toFixed(1)}%`
    },
    statusLabel(item) {
      if (item && item.accountStatus) {
        return item.accountStatus
      }
      return item && item.userId && item.userPlanId ? 'Liberação de plano' : 'Nova'
    },
    actionLabel(item) {
      if (item && item.action) {
        return item.action
      }
      return item && item.userId && item.userPlanId
        ? 'Liberação do plano para utilização pelo usuário.'
        : 'Convite para criar conta e usar o acesso foi enviado'
    },
    invitationStatus(item) {
      const { invitation } = item || {}
      if (!invitation) {
        return 'Convite substituído por outra importação'
      }
      if (invitation.userRegistered) {
        return 'Conta criada'
      }
      if (invitation.accessExpirationDate && new Date(invitation.accessExpirationDate).getTime() < Date.now()) {
        return 'Convite expirado'
      }
      return 'Aguardando cadastro'
    },
    getDaysUntilPurchase(item) {
      const { purchase } = item || {}
      if (!purchase || !purchase.bought || purchase.daysUntilPurchase == null) {
        return '-'
      }
      return purchase.daysUntilPurchase === 1
        ? '1 dia'
        : `${purchase.daysUntilPurchase} dias`
    },
    planStatus(status) {
      switch (status) {
        case 'paid':
          return 'Pago'
        case 'pending':
          return 'Pendente'
        case 'expired':
          return 'Expirado'
        case 'canceled':
          return 'Cancelado'
        case 'refunded':
          return 'Reembolsado'
        default:
          return '-'
      }
    },
    planName(plan) {
      switch (plan) {
        case 'MO1HO':
          return 'Mensal'
        case 'TRIAL':
          return 'Teste grátis'
        case 'AN1HO':
        case 'PROMO':
          return 'Anual'
        default:
          return 'Outro'
      }
    },
    getWhenHeResearchedTheFirstAgent(importEmailsPlanReleaseLog){
      const {chemicalAgentsResearched} = importEmailsPlanReleaseLog || {}
      if(!chemicalAgentsResearched || chemicalAgentsResearched.length <= 0){
        return '-'
      }
      const chemicalAgentResearched = chemicalAgentsResearched.at(-1);
      const {date} = chemicalAgentResearched || {};
      return date ? this.formatDateComplete(date) : '-'
    },
    getActivationDays(importEmailsPlanReleaseLog){
      const {chemicalAgentsResearched, userPlan, createdAt} = importEmailsPlanReleaseLog || {}
      if(!chemicalAgentsResearched || chemicalAgentsResearched.length <= 0){
        return '-'
      }
      const {lastPayment} = userPlan || {}
      const baseline = lastPayment || createdAt
      const chemicalAgentResearched = chemicalAgentsResearched.at(-1);
      const {date} = chemicalAgentResearched || {};
      if(!date || !baseline){
        return '-'
      }
      const diff = moment(new Date(date)).diff(moment(new Date(baseline)), 'days');
      return Number.isNaN(diff) ? '-' : diff;
    }
  },
  watch: {}
}
</script>

<style lang='scss' scoped>
.header {
  .title {
    font-weight: 700;
    font-size: 18px;
    color: #262626;
  }

  .btn-send-list-email {
    border: 1px solid #AEBBCD;
    border-radius: 5px;
    background: #FFFFFF;
    font-weight: 400;
    font-size: 14px;
    color: #6D7989;
  }
}

.border-none {
  border: none !important;
}

thead {
  font-weight: 600;
  font-size: 14px;
  color: #ECF0F3;
}

.file-name-access-expiration-date {
  font-weight: 400;
  font-size: 15px;
  color: #808080;
}

.title-group {
  font-weight: 700;
  font-size: 19px;
  color: #262626;
}

.alert-success-group {
  background: #04A8F366;
  border-radius: 6.25px;
  font-weight: 400;
  font-size: 16px;
  color: #022245;
}

.alert-pending-group {
  background: rgba(205, 0, 0, 0.2);
  border: 1px solid #CD0000;
  border-radius: 6.25px;
  font-weight: 500;
  font-size: 16px;
  color: #CD0000;
}
.item-li{
  font-weight: 400;
  font-size: 15px;
  color: #262626;
}

/* ===== Cabeçalho do log da importação (b-card) ===== */
.resume-b-card {
  border: 1px solid #E6E9EF;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(2, 34, 69, 0.06);
}

.resume-b-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  font-weight: 700;
  font-size: 15px;
  color: #022245;
  background: #F8FAFC;
  border-bottom: 1px solid #EDEFF4;
  cursor: pointer;
  user-select: none;
}

.resume-b-card__header--collapsed {
  border-bottom: none;
}

.resume-b-card__chevron {
  margin-left: auto;
  transition: transform 0.2s ease;
}

.resume-b-card__chevron--open {
  transform: rotate(180deg);
}

/* Lista de detalhes (chave / valor) */
.detail-list {
  list-style: none;
  padding: 6px 18px;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 24px;
}

.detail-list__item {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  border-bottom: 1px dashed #EDEFF4;
}

.detail-list__item:last-child,
.detail-list__item:nth-last-child(2) {
  border-bottom: none;
}

.detail-list__label {
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #8A94A6;
  margin-bottom: 2px;
}

.detail-list__value {
  font-weight: 500;
  font-size: 15px;
  color: #262626;
  word-break: break-word;
}

.detail-list__value--mono {
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
  font-size: 13px;
  color: #4A5568;
}

/* Métricas em destaque (b-card) */
.stat-b-card {
  border-radius: 8px;
  border: 1px solid transparent;
  min-height: 74px;

  ::v-deep .card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
  }
}

.stat-b-card__value {
  font-weight: 700;
  font-size: 22px;
  line-height: 1.1;
}

.stat-b-card__label {
  font-weight: 500;
  font-size: 11px;
  margin-top: 3px;
  line-height: 1.25;
}

.stat-b-card--neutral {
  background: #F4F6F9;
  border-color: #E6E9EF;
  .stat-b-card__value { color: #022245; }
  .stat-b-card__label { color: #6D7989; }
}

.stat-b-card--success {
  background: rgba(4, 168, 243, 0.10);
  border-color: rgba(4, 168, 243, 0.35);
  .stat-b-card__value { color: #0277BD; }
  .stat-b-card__label { color: #045a86; }
}

.stat-b-card--warning {
  background: rgba(205, 0, 0, 0.06);
  border-color: rgba(205, 0, 0, 0.25);
  .stat-b-card__value { color: #CD0000; }
  .stat-b-card__label { color: #9B2020; }
}

/* Taxas de conversão (b-card) */
.conversion-b-card {
  border: 1px solid #E6E9EF;
  border-radius: 8px;
  background: #FFFFFF;

  ::v-deep .conversion-b-card__body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 3px;
    padding: 10px 16px;
  }
}

.conversion-item__label {
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #8A94A6;
}

.conversion-item__value {
  font-weight: 700;
  font-size: 19px;
  color: #262626;

  small {
    font-weight: 500;
    font-size: 13px;
    color: #8A94A6;
  }
}
.w-12-5{
  width: 12.5%!important;
}
.w-11{
  width: 11.11%!important;
}
.action-text{
  font-size: 13px;
  color: #808080;
}
.invitation-icon{
  cursor: pointer;
  color: #022245;
}
</style>

<style lang='scss'>
.invitation-popover {
  max-width: 320px;

  .popover-header {
    background: #022245;
    color: #FFFFFF;
    font-weight: 700;
    font-size: 14px;
  }

  .invitation-popover-body {
    font-size: 14px;
    color: #262626;

    > div {
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }

      strong {
        color: #022245;
      }
    }
  }
}
</style>
